import { createSlice } from '@reduxjs/toolkit';
import { dispatcher } from '../../helpers/projectHelper';
import { set } from 'lodash';

const productPageV2 = createSlice({
  name: 'productPageV2',
  initialState: {
    // uploadedFiles: {},
    // completedFiles: [],
    activeView: 'DISPLAY', // DISPLAY, LIST
    productInfo: null,
    triggerProductUpdate: null,
    triggerProductContentUpdateForPresentationView: null,
    triggerProductContentUpdate: null,
    triggerProductCategoryUpdate: false,
    showEditorNudge: false,
    fetchModels: false,
    fetchTextures: false,
    showUpgradeMorePopup: false,
    sharePageData: null,
    publicLinkData:null,
    pdpProductDetails: null,
    pdpProductCountInfo: {},
    generateVisualModal: null,
    productImagesList: [],
  },
  reducers: {
    // setUploadedFiles: (state, { payload }) => {
    //   state.uploadedFiles.files = payload;
    // },
    // addFiles: (state, { payload }) => {
    //   state.uploadedFiles = { ...state.uploadedFiles, ...payload };
    // },
    // updateFile: (state, { payload }) => {
    //   if (state.uploadedFiles?.files?.[payload?.id]) {
    //     state.uploadedFiles.files[payload?.id] = payload;
    //   }
    // },
    // setCompletedFiles: (state, { payload }) => {
    //   state.completedFiles = [...state.completedFiles, payload];
    // },
    setActiveView: (state, { payload }) => {
      state.activeView = payload;
    },
    setProductImageList: (state, { payload }) => {
      state.productImagesList = payload;
    },
    setProductInfo: (state, { payload }) => {
      state.productInfo = payload;
    },
    setResetFiles: (state) => {
      state.uploadedFiles = {};
      state.completedFiles = [];
    },
    setTriggerProductUpdate: (state, { payload }) => {
      state.triggerProductUpdate = payload;
    },
    setTriggerProductContentUpdateForPresentationView: (state, { payload }) => {
      state.triggerProductContentUpdateForPresentationView = payload;
    },
    setTriggerProductContentUpdate: (state, { payload }) => {
      state.triggerProductContentUpdate = payload === null ? null : payload;
    },
    setTriggerProductCategoryUpdate: (state, { payload }) => {
      state.triggerProductCategoryUpdate = payload;
    },
    setShowEditorNudge: (state, { payload }) => {
      state.showEditorNudge = payload;
    },
    setFetchModels: (state, { payload }) => {
      state.fetchModels = payload;
    },
    setFetchTextures: (state, { payload }) => {
      state.fetchTextures = payload;
    },
    setShowUpgradeMorePopup: (state, { payload }) => {
      state.showUpgradeMorePopup = payload;
    },
    setShareProductPage: (state, { payload }) => {
      state.sharePageData = payload;
    },
    setSharePublicLinkData: (state, { payload }) => {
      state.publicLinkData = {...(state.publicLinkData || {}), ...(payload || {})} ;
    },
    setPdpProductDetails: (state, { payload }) => {
      state.pdpProductDetails = payload;
    },
    setPdpProductCountInfo: (state, { payload }) => {
      state.pdpProductCountInfo = payload;
    },
    setGenerateVisualModal: (state, { payload }) => {
      state.generateVisualModal = payload;
    }
  },
});

export const {
  //   setUploadedFiles,
  //   addFiles,
  //   updateFile,
  //   setResetFiles,
  //   setCompletedFiles,
  setActiveView,
  setProductImageList,
  setProductInfo,
  setTriggerProductUpdate,
  setTriggerProductContentUpdateForPresentationView,
  setTriggerProductContentUpdate,
  setTriggerProductCategoryUpdate,
  setShowEditorNudge,
  setFetchModels,
  setFetchTextures,
  setShowUpgradeMorePopup,
  setShareProductPage,
  setSharePublicLinkData,
  setPdpProductDetails,
  setPdpProductCountInfo,
  setGenerateVisualModal
} = productPageV2.actions;
export const productPageV2Selector = (state) => state.productPageV2;
export const productPageV2Reducer = productPageV2.reducer;
export default productPageV2Reducer;

// export const selectUploadedFiles = (state) => state.productPageV2.uploadedFiles;
// export const selectCompletedFiles = (state) => state.productPageV2.completedFiles;
export const selectActiveView = (state) => {
  const v = state.productPageV2.activeView;
  return {
    isListView: v === 'LIST',
    isDisplayView: v === 'DISPLAY',
  };
};
export const selectProductList = (state) => state.productPageV2.productImagesList;

export const selectPdpProductDetails = (state) => state.productPageV2.pdpProductDetails;
export const selectPdpProductCountInfo = (state) => state.productPageV2.pdpProductCountInfo;
export const selectShowUpgradeMorePopup = (state) => state.productPageV2.showUpgradeMorePopup;
export const selectShowEditorNudge = (state) => state.productPageV2.showEditorNudge;
export const selectProductInfo = (state) => state.productPageV2.productInfo;
export const selectTriggerProductUpdate = (state) => state.productPageV2.triggerProductUpdate;
export const selectTriggerProductContentUpdateForPresentationView = (state) =>
  state.productPageV2.triggerProductContentUpdateForPresentationView;
export const selectTriggerProductContentUpdate = (state) =>
  state.productPageV2.triggerProductContentUpdate;
export const selectTriggerProductCategoryUpdate = (state) =>
  state.productPageV2.triggerProductCategoryUpdate;

export const selectFetchModels = (state) => state.productPageV2.fetchModels;

export const selectFetchTextures = (state) => state.productPageV2.fetchTextures;
export const selectShareProductPageData = (state) => state.productPageV2.sharePageData;
export const selectPublicLinkData = (state) => state.productPageV2.publicLinkData;
export const selectGenerateVisualModal = (state) => state.productPageV2.generateVisualModal;
// export const selectUploadCompleted = (state) => {
//   if (
//     Object.keys(state.productPageV2.uploadedFiles?.files || {})?.length === 0 ||
//     state.productPageV2.completedFiles?.length === 0
//   )
//     return false;
//   return state.productPageV2.completedFiles.length === Object.keys(state.productPageV2.uploadedFiles?.files)?.length;
// };
